import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { ViewTitle } from '../components/reusable'
import { FFJApiView } from '../components/views/ffjApiView'

function FFJApi() {
    return (
        <div className="ffjApi">
            <Sidebar />
            <MainView>
                <ViewTitle text={'FFJ API'} />
                <FFJApiView />
            </MainView>
        </div>
    )
}

export default FFJApi
